import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6aa45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bonuses" }
const _hoisted_2 = { class: "bonuses__title" }
const _hoisted_3 = { class: "bonuses__subtitle" }
const _hoisted_4 = { class: "bonuses__form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "input-error coupon__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoPreloader = _resolveComponent("MoPreloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Бонусный баланс:"),
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.balance)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" В этом заказе можно списать: "),
      _createElementVNode("span", {
        class: _normalizeClass(["max-write-off-sum", { 'max-write-off-sum--active': !_ctx.bonusesWriteOffSum && +_ctx.bonusesMaxWriteOffSum !== 0}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setWriteOfSum(_ctx.bonusesMaxWriteOffSum)))
      }, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.bonusesMaxWriteOffSum)), 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bonusesCount) = $event)),
        type: "number",
        min: "1",
        class: _normalizeClass(["base-input base-input--black", { 'base-input--disabled': _ctx.bonusesWriteOffSum }])
      }, null, 2), [
        [_vModelText, _ctx.bonusesCount]
      ]),
      _hoisted_5,
      _createElementVNode("button", {
        class: _normalizeClass(["bonuses__btn base-btn base-btn--default", {
          'base-btn--blocked': _ctx.isLoading,
          'bonuses__btn--disabled': !_ctx.bonusesCount,
        }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bonusesWriteOffSum ? _ctx.reset() : _ctx.$emit('apply', _ctx.bonusesCount)))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_MoPreloader, {
              key: 0,
              "is-multiple": true
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.bonusesWriteOffSum)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Отменить ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Списать ")
                  ], 64))
            ], 64))
      ], 2)
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}